<template>
  <TemplatePromise v-slot="{ args, resolve }">
    <AppDataGridLookup
      v-bind="{ ...args[0] }"
      @cancel="resolve([])"
      @confirm="resolve"
    />
  </TemplatePromise>
</template>

<script setup lang="ts">
import { Resource } from "@q-food/q-food";

const TemplatePromise = createTemplatePromise<
  string[],
  [
    {
      resource: Resource;
      gridKey?: string;
      selectionMode?: "singleRow" | "multiRow";
      customResourceUrl?: string;
      filters?: string;
    }
  ]
>({
  singleton: true
});

defineExpose({
  start: TemplatePromise.start
});
</script>

<style scoped></style>
